import { useState } from "react";
import { Dialog, DialogContent } from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { comfirmPaymentStatus } from "../../api/orders";
import { toast } from "sonner";

interface PaymentConfirmModalProps {
  id: string | undefined;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PaymentConfirmModal({
  id,
  open,
  onOpenChange,
}: PaymentConfirmModalProps) {
  const handleConfirmPayment = async () => {
    try {
      if (id) {
        await comfirmPaymentStatus(id);
        toast.success("Оплата подтверждена");
        onOpenChange(false)
      }
    } catch (e) {
      const message = e instanceof Error ? e.message : "Ошибка";
      toast.error(message);
      console.error(e);
    }
  };
  return (
    <Dialog open={open} onOpenChange={() => onOpenChange(false)}>
      <DialogContent className="max-w-[560px] w-[560px] p-6">
        <h2 className="text-lg font-semibold text-gray-900">
          Вы уверены, что хотите проставить статус “Оплачено”? Эта операция
          необратима
        </h2>
        <div className="flex gap-3 w-full mt-2">
          <Button className="flex-1 h-10" onClick={() => onOpenChange(false)}>
            Отмена
          </Button>
          <Button
            variant="outline"
            className="flex-1 h-10"
            onClick={handleConfirmPayment}
          >
            Подтвердить
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
